import { useEffect, useMemo, useState } from 'react';
import { getLinkedClockCatalogues } from '../../../../services/deviceLinkingService';
import { builtInTemplates, resolveTemplates } from '../../../../utils/templateCatalogPolicy';

const language = () => (navigator.language || 'en').slice(0, 2).toLowerCase();

export const useClockTemplates = (selectedId) => {
  const [catalogues, setCatalogues] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    getLinkedClockCatalogues().then(c => {
      if (!alive) return;
      setCatalogues(c);
      setLoading(false);
    });
    return () => { alive = false; };
  }, []);
  const templates = useMemo(() => {
    const rows = resolveTemplates(builtInTemplates(), catalogues, language(), selectedId || 'adhanClock');
    // Before the first clock read resolves, `catalogues` is still `[]`, so resolveTemplates
    // falls back to the built-in list and may append the selected id as unavailable. Hide
    // that row while loading instead of flashing "Not available on your clock" briefly.
    return loading ? rows.filter(t => t.availableOnClock !== false) : rows;
  }, [catalogues, selectedId, loading]);
  return { templates, loading };
};
